"use client";

import * as React from "react";
import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseCashHome() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const benefits = ["Immediate liquidity with all-cash offers", "We cover all fees—title, closing, and transfer", "Fast and reliable transactions nationwide"];
  return <section id="why-choose-cashhome" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div ref={leftRef} className="space-y-6">
            <h2 className="font-display text-3xl md:text-4xl font-semibold text-foreground">
              Why Choose CashHome
            </h2>
            <ul className="space-y-4">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className={`flex items-start gap-3 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: leftVisible ? `${i * 100}ms` : "0ms"
            }}>
                  <div className="flex-shrink-0 mt-1">
                    <Check className="w-5 h-5 text-primary" strokeWidth={2.5} />
                  </div>
                  <p className="text-foreground text-base md:text-lg leading-relaxed">
                    {benefit}
                  </p>
                </li>)}
            </ul>
          </div>

          {}
          <div ref={rightRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="overflow-hidden rounded-lg shadow-medium transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.02]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1510319/img/why_choose_cashhome_benefits.png" alt="Why Choose CashHome" className="w-full h-auto object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}